/**
 * Shipment 导出列枚举
 */
export enum ExportFieldValue {
  Carrier = "carrier",
  CustomerEmail = "customer_email",
  CustomerName = "customer_name",
  CustomerPhoneNumber = "customer_phone_number",
  DeliveryDate = "delivery_date",
  DestinationCountry = "destination_country",
  DestinationProvince = "destination_province",
  FulfillmentDate = "fulfillment_date",
  LastCheckPoint = "last_check_point",
  LastCheckpointTime = "last_checkpoint_time",
  LastMileCarrier = "last_mile_carrier",
  LastMileTrackingNumber = "last_mile_tracking_number",
  Location = "location",
  Order = "order",
  OrderDate = "order_date",
  OrderToDeliveryTime = "order_to_delivery_time",
  PickupDate = "pickup_date",
  PickupTime = "pickup_time",
  ProcessingTime = "processing_time",
  ProductInfo = "product_info",
  ResidenceTime = "residence_time",
  ShippingProtection = "shipping_protection",
  Sku = "sku",
  Status = "status",
  Substatus = "substatus",
  TrackingLink = "tracking_link",
  TrackingNumber = "tracking_number",
  TransitTime = "transit_time",
}

/**
 * 导出字段项接口
 */
export interface ExportFieldItem {
  /**
   * 是否选中
   */
  selected: boolean
  value: ExportFieldValue
  [property: string]: any
}

/**
 * 导出字段集合
 */
export interface ShipmentsExportFields {
  data: ExportFieldItem[]
  [property: string]: any
}

/**
 * 导出字段请求接口
 */
export interface ExportFieldsRequest {
  shipments_export_fields: ShipmentsExportFields
  [property: string]: any
}

/**
 * 导出记录状态
 */
export enum ExportHistoryStatus {
  Processing = "processing",
  Completed = "completed",
  Failed = "failed",
}

/**
 * 一条导出记录
 */
export interface ExportHistoryItem {
  /** 加密 token，只用来换下载链接，不展示、不解析；同一条记录每次请求返回的值可能不同 */
  id: string
  file_name: string
  /** 导出行数，仅 completed 时有值 */
  shipments: number | null
  status: ExportHistoryStatus
  /** 后端已按店铺时区格式化（M d, g:i a），直接展示 */
  export_date: string
  /** 已完成、云端文件且在 2 天内才可下载 */
  downloadable: boolean
}

/**
 * 导出记录分页结果（游标分页，按导出时间倒序）
 */
export interface ExportHistoryPage {
  list: ExportHistoryItem[]
  /** 下一页游标，为空表示没有更多 */
  next_cursor: string | null
  has_more: boolean
}
